import { Select } from "antd"
import { kebabCase } from "lodash"
import PropTypes from "prop-types"
import { warning } from "../../../helpers"

SelectField.propTypes = {
  options: PropTypes.any,
  id: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  mode: PropTypes.any,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  defaultValue: PropTypes.any
}

export function SelectField({
  options,
  id,
  name,
  disabled = false,
  onChange,
  mode,
  placeholder = "Selecciona...",
  defaultValue,
  value,
  monthsDisabled,
  blockOptions = [],
  isAdmin = false,
  returnOnlyValue = false,
  ...props
}) {

  const onSelectChange = value => {

    if ((monthsDisabled ?? []).includes(value) && !isAdmin) {
      return warning("El mes de asignación esta bloqueado por revisión, ingresa otro mes")
    } else {

      if (returnOnlyValue) {
        onChange?.(value)
      } else {

        onChange?.({
          currentTarget: {
            id: id,
            value: value
          }
        }, [value])
      }

    }
  }

  return (
    <Select
      id={id}
      name={name}
      disabled={disabled}
      onChange={onSelectChange}
      placeholder={placeholder}
      mode={mode}
      defaultValue={defaultValue}
      value={value}
      {...props}>
      {options?.map((o, i) =>
        <Select.Option
          disabled={o.disabled || (blockOptions.includes(o.value) && !isAdmin)}
          key={kebabCase(`${o.value}-${i}`)}
          value={o.value}>
          {o.label}
        </Select.Option>
      )}
    </Select>
  )
}
